<div *ngFor="let error of errorList">
    <span class="fad fa-exclamation-triangle"></span> {{ error.name }}:
    {{ error.message }}
</div>

<div *ngIf="errorList.length === 0">
    <span class="fa fa-check green-tick"></span> No errors
</div>
